import { AggregatorAccount, Car, Driver, Subdivision } from '~/shared/api'
import {
  transactionBalanceTypeEnumOptions,
  transactionMoveFundsTypeEnumOptions,
} from '~/shared/config/constants'
import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'appliedAtFrom',
    label: 'filter.period start',
    type: 'date',
  },
  {
    field: 'appliedAtTo',
    label: 'filter.period end',
    type: 'date',
  },
  {
    field: 'moveFundsType',
    label: 'filter.movement type',
    type: 'select',
    options: transactionMoveFundsTypeEnumOptions,
  },
  {
    field: 'aggregatorAccountId',
    label: 'filter.account',
    type: 'autocomplete',
    fetchOptions: AggregatorAccount.fetchOptions,
  },
  {
    field: 'driverId',
    label: 'filter.driver',
    type: 'autocomplete',
    fetchOptions: Driver.fetchOptions,
  },
  {
    field: 'carId',
    label: 'filter.car',
    type: 'autocomplete',
    fetchOptions: Car.fetchOptions,
  },
  {
    field: 'balanceType',
    label: 'filter.balance section',
    type: 'select',
    options: transactionBalanceTypeEnumOptions,
  },
  {
    field: 'flowStatementName',
    label: 'filter.turnover item',
    type: 'text',
  },
  {
    field: 'subdivisionId',
    label: 'filter.subdivision',
    type: 'autocomplete',
    fetchOptions: Subdivision.fetchOptions,
  },
  {
    field: 'sourceType',
    label: 'filter.user or source',
    type: 'text',
  },
]
